import type { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

const FiltersLoadingSkeleton: FC = () => (
  <div className="flex items-center mb-12">
    <div className="w-6 h-6 mr-5">
      <Skeleton className="w-6 h-6" circle />
    </div>

    <div className="w-2/5">
      <Skeleton height={35} />
    </div>

    <div className="w-32 ml-1">
      <Skeleton height={35} className="w-32" />
    </div>
  </div>
);

export default FiltersLoadingSkeleton;
